<template>
  <form>
    <MnLoader :visible="formState.state.isProcessing" :message="formState.state.message" />
    <div v-if="isFormInitialized" class="p-2">
      <Fluid>
        <MnRow >
          <MnColumn cols="6">
            <FormSelectGroup label="Organization Type" 
                             inputId="org-type-input" 
                             :state="formState.state.$v.organizationTypeId.$error"
                             :errorMessage="formState.state.$v.organizationTypeId.$errors[0]?.$message"
                             required>
              <template #default="{ state, updateState }">
                <PvSelect ref="orgTypeRef" 
                          inputId="org-type-input" 
                          v-model="formState.state.$v.organizationTypeId.$model" 
                          :options="filteredOrganizationTypes"
                          :invalid="state"
                          @change="updateOrganizationType($event)"
                          @input="updateState($event)"
                          placeholder="-- Select Type --"
                          optionValue="attributeId"
                          optionLabel="textValue1" />
              </template>
            </FormSelectGroup>
          </MnColumn>
          <MnColumn v-if="formState.state.data.isNew" cols="6">
            <FormSelectGroup label="Parent Organization" 
                             inputId="org-parent-input" 
                             :state="formState.state.$v.parentOrganizationId.$error"
                             :errorMessage="formState.state.$v.parentOrganizationId.$errors[0]?.$message"
                             required>
              <template #default="{ state, updateState }">
                <PvSelect id="org-parent-input" 
                          v-model="formState.state.$v.parentOrganizationId.$model" 
                          :options="parentOrganizations"
                          :invalid="state"
                          @input="updateState($event)"
                          placeholder="-- Select Type --"
                          optionValue="organizationId"
                          optionLabel="organizationName" />
              </template>
            </FormSelectGroup>            
          </MnColumn>
        </MnRow>
        <MnRow>
          <MnColumn>
            <FormInputGroup label="Organization Name"
                            inputId="org-name"
                            :state="formState.state.$v.name.$error"   
                            :errorMessage="formState.state.$v.name.$errors[0]?.$message"
                            :required="fieldAccess.name.required">
              <template #default="{ state, updateState }">
                <PvInputText id="org-name"
                             :invalid="state"
                             v-model="formState.state.$v.name.$model"
                             @input="updateState($event)" />
              </template>

            </FormInputGroup>
          </MnColumn>
        </MnRow>
        <MnRow>
          <MnColumn v-if="fieldAccess.naicNumber.visible || fieldAccess.npiNumber.visible" cols="6">
            <FormInputGroup label="NPI" 
                            inputId="org-npi-input" 
                            :state="formState.state.$v.npiNumber.$error"
                            :errorMessage="formState.state.$v.npiNumber.$errors[0]?.$message"
                            v-if="fieldAccess.npiNumber.visible" 
                            :required="fieldAccess.npiNumber.required">
              <template #default="{ state, updateState }">
                <PvInputText id="org-npi-input"
                             :invalid="state"
                             v-model="formState.state.$v.npiNumber.$model"
                             @input="updateState($event)" />
              </template>
            </FormInputGroup>
            <FormInputGroup label="NAIC" 
                            inputId="org-naic-input" 
                            :state="formState.state.$v.naicNumber.$error"
                            :errorMessage="formState.state.$v.naicNumber.$errors[0]?.$message"
                            v-if="fieldAccess.naicNumber.visible" 
                            :required="fieldAccess.naicNumber.required">
              <template #default="{ state, updateState }">
                <PvInputText id="org-naic-input"
                             :invalid="state"
                             v-model="formState.state.$v.naicNumber.$model"
                             @input="updateState($event)" />
              </template>
            </FormInputGroup>
          </MnColumn>
          <MnColumn v-if="fieldAccess.groupCode.visible" cols="6">
            <FormInputGroup label="Group Code"
                            inputId="org-groupcode-input"
                            :state="formState.state.$v.groupCode.$error"
                            :errorMessage="formState.state.$v.groupCode.$errors[0]?.$message"
                            :required="fieldAccess.groupCode.required">
              <template #default="{ state, updateState }">
                <PvInputText id="org-groupcode-input"
                             :invalid="state"
                             v-model="formState.state.$v.groupCode.$model"
                             @input="updateState($event)" />
              </template>
            </FormInputGroup>
          </MnColumn>
          <MnColumn v-if="fieldAccess.taxId.visible" cols="6">
            <FormInputGroup label="Tax ID"
                            inputId="org-taxid-input"
                            :state="formState.state.$v.taxId.$error"
                            :errorMessage="formState.state.$v.taxId.$errors[0]?.$message"
                            :required="fieldAccess.taxId.required">
              <template #default="{ state, updateState }">
                <PvInputText id="org-taxid-input"
                             :invalid="state"
                             v-model="formState.state.$v.taxId.$model"
                             @input="updateState($event)" />
              </template>
            </FormInputGroup>
          </MnColumn>
        </MnRow>
        <MnRow v-if="addressVisiblity.isPhysicalAddressVisible">
          <MnColumn>
            <div class="p-3 border rounded my-2">
              <div class="d-flex w-100 align-items-center mb-3 justify-content-between">
                <div id="physical-address-lbl" class="p-panel-title">Physical Address</div>
                <div>
                  <PvButton icon="pi pi-copy" size="small" outlined rounded severity="secondary" label="Use Parent Organization Address" @click="setPhysicalAddressToParent" />
                </div>
              </div>
              <MnRow>
                <MnColumn>
                  <FormInputGroup label="Address"
                                  inputId="org-address"
                                  :state="formState.state.$v.address1.$error"
                                  :errorMessage="formState.state.$v.address1.$errors[0]?.$message"
                                  :required="fieldAccess.address1.required">
                    <template #default="{ state, updateState }">
                      <PvInputText id="org-address"
                                   :invalid="state"
                                   v-model="formState.state.$v.address1.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
              </MnRow>
              <MnRow>
                <MnColumn>
                  <FormInputGroup label="Address 2"
                                  inputId="org-address2"
                                  :state="formState.state.$v.address2.$error"
                                  :errorMessage="formState.state.$v.address2.$errors[0]?.$message"
                                  :required="fieldAccess.address2.required">
                    <template #default="{ state, updateState }">
                      <PvInputText id="org-address2"
                                   :invalid="state"
                                   v-model="formState.state.$v.address2.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
              </MnRow>
              <MnRow>
                <MnColumn cols="5">
                  <FormInputGroup label="City" 
                                  inputId="org-city" 
                                  :state="formState.state.$v.city.$error"
                                  :errorMessage="formState.state.$v.city.$errors[0]?.$message"
                                  :required="fieldAccess.city.required">
                    <template #default="{ state, updateState }">
                      <PvInputText id="org-city"
                                   :invalid="state"
                                   v-model="formState.state.$v.city.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
                <MnColumn cols="3">
                  <FormSelectGroup label="State" 
                                   inputId="org-state-input" 
                                   :state="formState.state.$v.stateProvince.$error"
                                   :errorMessage="formState.state.$v.stateProvince.$errors[0]?.$message"
                                   :required="fieldAccess.stateProvince.required">
                    <template #default="{ state, updateState }">
                      <PvSelect id="org-state-input" 
                                v-model="formState.state.$v.stateProvince.$model"
                                :options="states"
                                :invalid="state"
                                placeholder="-- Select State --"
                                optionLabel="text"
                                optionValue="value"
                                @input="updateState($event)" />
                    </template>
                  </FormSelectGroup>
                </MnColumn>
                <MnColumn cols="4">
                  <FormInputGroup label="Postal Code" 
                                  inputId="org-postal-input" 
                                  :state="formState.state.$v.postalCode.$error"
                                  :errorMessage="formState.state.$v.postalCode.$errors[0]?.$message"
                                  :required="fieldAccess.postalCode.required">
                    <template #default="{ state, updateState }">
                      <PvInputMask id="org-postal-input"
                                   mask="99999?-9999"
                                   v-model="formState.state.$v.postalCode.$model"
                                   :invalid="state"
                                   @input="updateState" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
              </MnRow>
              <MnRow v-if="fieldAccess.countyId.visible">
                <MnColumn cols="6">
                  <FormSelectGroup label="County" 
                                   inputId="org-county-input" 
                                   :state="formState.state.$v.countyId.$error"
                                   :errorMessage="formState.state.$v.countyId.$errors[0]?.$message"
                                   :required="fieldAccess.countyId.required">
                    <template #default="{ state, updateState }">
                      <PvSelect id="org-county-input"
                                v-model="formState.state.$v.countyId.$model"
                                :options="allowedCounties"
                                placeholder="Select County"
                                optionValue="countyId"
                                optionLabel="countyName"
                                :invalid="state"
                                @change="updateCounty($event)"
                                @input="updateState($event)" />
                    </template>
                  </FormSelectGroup>
                </MnColumn>
                <MnColumn v-if="showOtherCountyName" cols="6">
                  <FormInputGroup label="County Name"
                                  inputId="org-other-county-name-input"
                                  :state="formState.state.$v.otherCountyName.$error"
                                  :errorMessage="formState.state.$v.otherCountyName.$errors[0]?.$message"
                                  :required="fieldAccess.otherCountyName.required" >
                    <template #default="{ state, updateState }">
                      <PvInputText id="org-other-county-name-input"
                                   :invalid="state"
                                   v-model="formState.state.$v.otherCountyName.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
              </MnRow>
            </div>
          </MnColumn>
        </MnRow>        
        <MnRow v-if="addressVisiblity.isMailingAddressVisible">
          <MnColumn>
            <div class="p-3 border rounded mb-2">
              <div class="d-flex w-100 align-items-center mb-3 justify-content-between">
                <div id="mail-address-lbl" class="p-panel-title">Mailing Address</div>
                <div v-if="fieldAccess.showPhysicalAddress">
                  <PvButton icon="pi pi-copy" size="small" outlined rounded severity="secondary" label="Copy Physical Address" @click="setOrganizationMailingToPhysical" />
                </div>
              </div>
              <MnRow>
                <MnColumn>
                  <FormInputGroup label="Address"
                                  inputId="org-mail-address-input"
                                  :state="formState.state.$v.mailAddress1.$error"
                                  :errorMessage="formState.state.$v.mailAddress1.$errors[0]?.$message"
                                  :required="fieldAccess.mailAddress1.required">
                    <template #default="{ state, updateState }">
                      <PvInputText id="org-mail-address-input"
                                   :invalid="state"
                                   v-model="formState.state.$v.mailAddress1.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
              </MnRow>
              <MnRow>
                <MnColumn>
                  <FormInputGroup label="Address 2"
                                  inputId="org-mail-address2-input"
                                  :state="formState.state.$v.mailAddress2.$error"
                                  :errorMessage="formState.state.$v.mailAddress2.$errors[0]?.$message"
                                  :required="fieldAccess.mailAddress2.required" >
                    <template #default="{ state, updateState }">
                      <PvInputText id="org-mail-address2-input"
                                   :invalid="state"
                                   v-model="formState.state.$v.mailAddress2.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
              </MnRow>
              <MnRow>
                <MnColumn cols="5">
                  <FormInputGroup label="City"
                                  inputId="org-mail-city-input"
                                  :state="formState.state.$v.mailCity.$error"
                                  :errorMessage="formState.state.$v.mailCity.$errors[0]?.$message"
                                  :required="fieldAccess.mailCity.required">
                    <template #default="{ state, updateState }">
                      <PvInputText id="org-mail-city-input"
                                   :invalid="state"
                                   v-model="formState.state.$v.mailCity.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
                <MnColumn cols="4">
                  <FormSelectGroup label="State"
                                   inputId="org-mail-state-input"
                                   :state="formState.state.$v.mailStateProvince.$error"
                                   :errorMessage="formState.state.$v.mailStateProvince.$errors[0]?.$message"
                                   :required="fieldAccess.mailStateProvince.required">
                    <template #default="{ state, updateState }">
                      <PvSelect id="org-mail-state-input"
                                v-model="formState.state.$v.mailStateProvince.$model"
                                :options="states"
                                :invalid="state"
                                @input="updateState($event)"
                                placeholder="-- Select State --"
                                optionLabel="text"
                                optionValue="value" />
                    </template>
                  </FormSelectGroup>
                </MnColumn>
                <MnColumn cols="3">
                  <FormInputGroup label="Postal Code"
                                  inputId="org-mail-postal-input"
                                  :state="formState.state.$v.mailPostalCode.$error"
                                  :errorMessage="formState.state.$v.mailPostalCode.$errors[0]?.$message"
                                  :required="fieldAccess.mailPostalCode.required">
                    <template #default="{ state, updateState }">
                      <PvInputMask id="org-mail-postal-input"
                                   :invalid="state"
                                   :mask=INPUT_MASKS.PostalCode
                                   v-model="formState.state.$v.mailPostalCode.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
              </MnRow>
              <MnRow v-if="fieldAccess.mailCountyId.visible">
                <MnColumn cols="6">
                  <FormSelectGroup label="County" 
                                   inputId="org-mail-county-input" 
                                   :state="formState.state.$v.mailCountyId.$error"
                                   :errorMessage="formState.state.$v.mailCountyId.$errors[0]?.$message"
                                   :required="fieldAccess.mailCountyId.required">
                    <template #default="{ state, updateState }">
                      <PvSelect id="org-county-input"
                                v-model="formState.state.$v.mailCountyId.$model"
                                :options="allowedMailCounties"
                                placeholder="Select County"
                                optionValue="countyId"
                                optionLabel="countyName"
                                :invalid="state"
                                @change="updateMailCounty($event)"
                                @input="updateState($event)" />
                    </template>
                  </FormSelectGroup>
                </MnColumn>
                <MnColumn v-if="showMailOtherCountyName" cols="6">
                  <FormInputGroup label="County Name"
                                  inputId="org-mail-other-county-name-input"
                                  :state="formState.state.$v.mailOtherCountyName.$error"
                                  :errorMessage="formState.state.$v.mailOtherCountyName.$errors[0]?.$message"
                                  :required="fieldAccess.mailOtherCountyName.required" >
                    <template #default="{ state, updateState }">
                      <PvInputText id="org-mail-other-county-name-input"
                                   :invalid="state"
                                   v-model="formState.state.$v.mailOtherCountyName.$model"
                                   @input="updateState($event)" />
                    </template>
                  </FormInputGroup>
                </MnColumn>
              </MnRow>              
            </div>  
          </MnColumn>
        </MnRow>         
        <MnRow>
          <MnColumn cols="6">
            <FormInputGroup label="Phone" 
                            inputId="org-phone-input" 
                            :state="formState.state.$v.phone.$error"
                            :errorMessage="formState.state.$v.phone.$errors[0]?.$message"
                            :required="fieldAccess.phone.required">
              <template #default="{ state, updateState }">
                <PvInputMask id="org-phone-input"
                             mask="(999) 999-9999"
                             v-model="formState.state.$v.phone.$model"
                             :invalid="state"
                             @input="updateState" />
              </template>
            </FormInputGroup>
          </MnColumn>   
          <MnColumn cols="6">
            <FormInputGroup label="Fax" 
                            inputId="org-fax-input" 
                            :state="formState.state.$v.fax.$error"
                            :errorMessage="formState.state.$v.fax.$errors[0]?.$message"
                            :required="fieldAccess.fax.required">
              <template #default="{ state, updateState }">
                <PvInputMask id="org-fax-input"
                             mask="(999) 999-9999"
                             v-model="formState.state.$v.fax.$model"
                             :invalid="state"
                             @input="updateState" />
              </template>
            </FormInputGroup>
          </MnColumn>
        </MnRow>        
        <MnRow>
          <MnColumn v-if="fieldAccess.fiscalYearEnd.visible" cols="6">
            <FormInputGroup label="Fiscal Year End" 
                            inputId="org-yearend-input" 
                            :state="formState.state.$v.fiscalYearEnd.$error"
                            :errorMessage="formState.state.$v.fiscalYearEnd.$errors[0]?.$message"
                            :required="fieldAccess.fiscalYearEnd.required">
              <template #default="{ state, updateState }">
                <PvDatePicker inputId="org-yearend-input"
                              :modelValue="formState.state.$v.fiscalYearEnd.$model"
                              @update:modelValue="handleFiscalYearEndChange"
                              :showIcon="true"
                              :showButtonBar="true"
                              :showOnFocus="true"
                              :showTime="false"
                              :invalid="state"
                              :placeholder="''"
                              @input="updateState($event)" />             
              </template>
            </FormInputGroup>
          </MnColumn>
        </MnRow>
        <MnRow>
          <MnColumn cols="12">
            <FormInputGroup label="Website" 
                            inputId="org-website-input" 
                            :state="formState.state.$v.webUrl.$error"
                            :errorMessage="formState.state.$v.webUrl.$errors[0]?.$message"
                            :required="fieldAccess.webUrl.required">
              <template #default="{ state, updateState }">
                <PvInputText id="org-website-input"
                             :invalid="state"
                             v-model="formState.state.$v.webUrl.$model"
                             @input="updateState($event)" />
              </template>
            </FormInputGroup>
          </MnColumn>
        </MnRow>
        <MnRow v-if="showOpenCloseDates">
          <MnColumn cols="6">
            <FormSelectGroup label="Open Date" 
                             inputId="org-opendate-input" 
                             :state="formState.state.$v.openDate.$error"
                             :errorMessage="formState.state.$v.openDate.$errors[0]?.$message">
              <template #default="{ state, updateState }">
                <PvDatePicker id="org-opendate-input"
                              v-model="formState.state.$v.openDate.$model"
                              :showIcon="true"
                              :showButtonBar="true"
                              :showOnFocus="true"
                              :invalid="state"
                              :showTime="false"
                              @input="updateState($event)" />             
              </template>
            </FormSelectGroup>
          </MnColumn>
          <MnColumn cols="6">
            <FormSelectGroup label="Close Date" 
                             inputId="org-closedate-input" 
                             :state="formState.state.$v.closeDate.$error"
                             :errorMessage="formState.state.$v.closeDate.$errors[0]?.$message">
              <template #default="{ state, updateState }">
                <PvDatePicker id="org-closedate-input"
                              v-model="formState.state.$v.closeDate.$model"
                              :showIcon="true"
                              :showButtonBar="true"
                              :showOnFocus="true"
                              :showTime="false"
                              :placeholder="''"
                              :invalid="state"
                              @input="updateState($event)" />             
              </template>
            </FormSelectGroup>
          </MnColumn>
        </MnRow>
        <MnRow v-if="!formState.state.data.isPendingApproval && !formState.state.data.isNew">
          <MnColumn>
            <div class="d-flex justify-content-center border rounded p-3">
              <div class="text-center me-3">
                <span id="active-switch-lbl" class="mb-2">Status</span>
                <div>
                  <ToggleButton inputId="active-switch" aria-labelledby="active-switch-lbl" :disabled="formState.state.data.isNew" onLabel="Active" class="toggle-btn" onIcon="pi pi-check-circle" severity="success" offLabel="Inactive" offIcon="pi pi-times-circle" v-model="formState.state.$v.isActive.$model"  />
                </div>
              </div>
            </div>
          </MnColumn>
        </MnRow>        
      </Fluid>    
    </div>  
  </form>
  <PvDialog v-model:visible="isFyeDialogVisible" header="Fiscal Year End Change" :modal="true" :closable="false" :style="{ width: '50vw' }">
    <template #header>
      <div>
        <span class="fs-3">Fiscal Year End Change</span>
      </div>
    </template>
    <div>
      <PvTextarea id="fye-explanation" 
                  v-model="formState.state.$v.fiscalYearEndChangeExplanation.$model" 
                  rows="10" 
                  placeholder="Please provide an explanation for fiscal year end change." :style="{ width: '100%' }" />
    </div>
    <template #footer>
      <div class="d-flex">
        <PvButton type="button" class="me-2" label="Save Explanation" @click="saveFyeExplanation" rounded raised  />
        <PvButton type="button" rounded raised @click="cancelFyeExplanation" label="Cancel" severity="secondary" />
      </div>
    </template>
  </PvDialog>
  <ErrorMessage id="error-msg" :visible="formState.state.hasError" :message="formState.state.errorMessage"  />  
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { ref, computed, nextTick, onMounted, watch } from 'vue';

// Components

import Fluid from 'primevue/fluid';
import MnLoader from '../common/MnLoader.vue';
import MnColumn from '../common/MnColumn.vue';

// Composables
import { useUpperCaseStateOptions } from '@/composables/commonOptions';
import { useFormHelper } from '@/composables/formHelper';
import { getOrganizationTypes, getCounties } from '@/services/RegistrationAPIService';
import { getOrganizationParents, getOrganization } from '@/services/organizationLambda';
import MnRow from '../common/MnRow.vue';
import FormInputGroup from '../common/FormInputGroup.vue';
import ErrorMessage from '../common/ErrorMessage.vue';
import ToggleButton from 'primevue/togglebutton';
import FormSelectGroup from '../common/FormSelectGroup.vue';
import { useFieldAccessState } from '@/composables/FieldAccessState';
import { OrganizationModel } from '@/models/OrganizationModel';

// Stores
import { useAuthStore } from '@/stores/authStore';

// Constants and Utils
import { MODEL_TYPES, ORGANIZATION_TYPES, INPUT_MASKS } from '../../utils/constants';
import { mapOrganizationTypeToShort } from '@/utils/organizationUtils';

// ===============================
// PROPS & EMITS
// ===============================
const props = defineProps({
    organizationId: {
        type: Number,
        default: null
    },
    parentOrganizationId: {
        type: Number,
        default: null
    },
    parentOrganizationType: {
        type: String,
        default: null
    }
});

const emit = defineEmits(['data-saved', 'data-canceled']);

// ===============================
// COMPOSABLES & STORES
// ===============================
const store = useAuthStore();
const formState = useFormHelper(new OrganizationModel(), OrganizationModel.getValidationRules());
const { getAllFieldAccess, showPhysicalAddress, showMailingAddress } = useFieldAccessState();

// ===============================
// REACTIVE STATE
// ===============================
const counties = ref(null);
const mailCounties = ref(null);
const allOrganizationTypes = ref(null);
const filteredOrganizationTypes = ref(null);
const parentOrganizations = ref(null);
const parentOrganization = ref(null);
const isFyeDialogVisible = ref(false);
const fieldAccess = ref(null);

// ===============================
// CONSTANTS
// ===============================
const states = useUpperCaseStateOptions();

// ===============================
// COMPUTED PROPERTIES
// ===============================
const showOpenCloseDates = computed(() => store.user.isAdminUser);
const showOtherCountyName = computed(() => {
  return formState.state.data.countyId == 0;
});
const showMailOtherCountyName = computed(() => {
  return formState.state.data.mailCountyId == 0;
});

const addressVisiblity = computed(() => {
    const orgTypeId = formState.state.data.organizationTypeId;
    const orgTypeDesc = allOrganizationTypes.value?.find(x => x.attributeId === orgTypeId)?.textValue1;
    return {
      isPhysicalAddressVisible: showPhysicalAddress(mapOrganizationTypeToShort()[orgTypeDesc]),
      isMailingAddressVisible: showMailingAddress(mapOrganizationTypeToShort()[orgTypeDesc]),
    };
});

const isFormInitialized = computed(() => {
  return formState.state.data != null && fieldAccess.value != null;
});

const allowedCounties = computed(() => {
  const state = formState.state.data.stateProvince;
  if (!counties.value) return [];
  return state === 'MN' ? counties.value.filter(county => county.countyId !== 0) : counties.value.filter(county => county.countyId === 0);
});

const allowedMailCounties = computed(() => {
  const state = formState.state.data.mailStateProvince;
  if (!mailCounties.value) return [];
  return state === 'MN' ? mailCounties.value.filter(county => county.countyId !== 0) : mailCounties.value.filter(county => county.countyId === 0);
});

// ===============================
// METHODS
// ===============================
const handleFiscalYearEndChange = (event) => {
  formState.state.$v.fiscalYearEnd.$model = event;
  if (formState.state.data.isNew) {
    return;
  }
  
  isFyeDialogVisible.value = true;
  nextTick(() => formState.setFocus('fye-explanation'));
};

const onSubmit = async () => {
  formState.state.$v.$touch();
  if (formState.state.$v.$invalid) {
    nextTick(() => formState.focusFirstInvalidInput());
  } else {
    await formState.save(() => formState.state.data.save());
    if (!formState.state.hasError) {
      emit('data-saved');
    } else {
      formState.focusErrorMessage('error-msg');
    }
  }
};

const updateCounty = (event) => {
  if (event.value > 0) {
    formState.state.data.otherCountyName = '';
  }
};

const updateMailCounty = (event) => {
  if (event.value > 0) {
    formState.state.data.mailOtherCountyName = '';
  }
};

const setFieldAccess = () => {
  fieldAccess.value = getAllFieldAccess(MODEL_TYPES.Organization, mapOrganizationTypeToShort()[formState.state.data.organizationTypeDesc]);
};

const updateOrganizationType = (event) => {
  const orgType = allOrganizationTypes.value.find(x => x.attributeId === event.value)?.textValue1;
  formState.state.data.organizationTypeDesc = orgType;
  setFieldAccess();
};

const setOrganizationMailingToPhysical = () => {
  formState.state.data.setMailingAddressToPhysical();

};

const setPhysicalAddressToParent = async () => {
  parentOrganization.value = await getOrganization(formState.state.data.parentOrganizationId);
  formState.state.data.setPhysicalAddressToParent(parentOrganization.value);
};

const initializePage = async () => {
  // Load the organization types and counties
  const [organizationTypes, countiesData] = await Promise.all([
      getOrganizationTypes(),
      getCounties()
    ]);


  allOrganizationTypes.value = organizationTypes;
  counties.value = countiesData.sort((a, b) => a.countyName.localeCompare(b.countyName));
  mailCounties.value = countiesData.sort((a, b) => a.countyName.localeCompare(b.countyName));



    // Load the organization data if an organization ID was passed  
  if (props.organizationId) {
    await formState.state.data.fetch(props.organizationId);
    filterOrganizationTypes(formState.state.data.organizationTypeDesc);
  } else {
    filterOrganizationTypes(props.parentOrganizationType);
    const orgType = allOrganizationTypes.value.find(x => x.textValue1 == props.parentOrganizationType);
    if (orgType) {
      formState.state.data.organizationTypeId = orgType.attributeId;
      formState.state.data.organizationTypeDesc = orgType.textValue1;
      formState.state.data.parentOrganizationId = props.parentOrganizationId;
      parentOrganizations.value = await getOrganizationParents(props.parentOrganizationId);
    }
  }

  setFieldAccess();
};

const filterOrganizationTypes = (orgType) => {

  if (orgType) {
    if (orgType == ORGANIZATION_TYPES.FOSC || orgType == ORGANIZATION_TYPES.DI || orgType == ORGANIZATION_TYPES.HP || orgType == ORGANIZATION_TYPES.URO || orgType == ORGANIZATION_TYPES.CEX) {
      filteredOrganizationTypes.value = allOrganizationTypes.value.filter(x => x.numericValue1 === 1);
    } else if (orgType == ORGANIZATION_TYPES.HCE) {
      filteredOrganizationTypes.value = allOrganizationTypes.value.filter(x => x.numericValue1 === 2);
    } else if (orgType == ORGANIZATION_TYPES.Internal || orgType == ORGANIZATION_TYPES.Anchor) {
      filteredOrganizationTypes.value = allOrganizationTypes.value.filter(x => x.numericValue1 === 0 || x.textValue1 != "Anchor");
    }
  }
};

function onCancel() {
    emit('data-canceled');
}

const saveFyeExplanation = () => {
  if (formState.state.$v.fiscalYearEndChangeExplanation.$model.trim() === '') {
    formState.state.$v.fiscalYearEnd.$model = formState.state.data.initialFiscalYearEnd;
    formState.state.$v.fiscalYearEndChangeExplanation.$model = '';
    isFyeDialogVisible.value = false;
    return;
  }

  isFyeDialogVisible.value = false;
};

const cancelFyeExplanation = () => {
  formState.state.$v.fiscalYearEnd.$model = formState.state.data.initialFiscalYearEnd;  
  formState.state.$v.fiscalYearEndChangeExplanation.$model = '';
  isFyeDialogVisible.value = false;
};

// ===============================
// WATCHERS
// ===============================
watch(() => formState.state.data.stateProvince, (newValue, oldValue) => {
  if (oldValue === '') {
    return;
  }
  if (newValue !== 'MN') {
    formState.state.$v.countyId.$model = 0;
    formState.state.data.otherCountyName = '';
  } else {
    formState.state.$v.countyId.$model = null;
    formState.state.data.otherCountyName = '';
  }
});

watch(() => formState.state.data.mailStateProvince, (newValue) => {
  if (formState.state.isProcessing) {
    return;
  }
  if (newValue !== 'MN') {
    formState.state.$v.mailCountyId.$model = 0;
    formState.state.data.mailOtherCountyName = '';
  } else {
    formState.state.$v.mailCountyId.$model = null;
    formState.state.data.mailOtherCountyName = '';
  }
});

// ===============================
// LIFECYCLE HOOKS
// ===============================
onMounted(async () => {
  await formState.fetch(() => initializePage());

  nextTick(() => { formState.focusFirstEnabledInput(); });
});


// ===============================
// EXPOSE
// ===============================
defineExpose({ onSubmit, onCancel });

</script>